import { render, staticRenderFns } from "./TabSwitcher.vue?vue&type=template&id=09895d4f&scoped=true"
import script from "./TabSwitcher.vue?vue&type=script&lang=js"
export * from "./TabSwitcher.vue?vue&type=script&lang=js"
import style0 from "./TabSwitcher.vue?vue&type=style&index=0&id=09895d4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09895d4f",
  null
  
)

export default component.exports